import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import QrModal from './QrModal';
import './PeerCard.css';

export default function PeerCard({ peer }) {
  const { getAccessTokenSilently } = useAuth0();
  const [showQr, setShowQr] = useState(false);

  const handleDownload = async () => {
    const token = await getAccessTokenSilently();
    const res = await fetch(`/api/vpn/peers/${peer.id}/download`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return;
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `peer${peer.id}.conf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const displayName = peer.pretty_name || `Peer ${peer.id}`;

  return (
    <>
      {showQr && <QrModal peer={peer} onClose={() => setShowQr(false)} />}
      <div className={`peer-card ${peer.online ? 'peer-online' : ''}`}>
        <div className="card-header">
          <div className="card-name">{displayName}</div>
          <span className={`card-status ${peer.online ? 'online' : 'offline'}`}>
            {peer.online ? '● Online' : '○ Offline'}
          </span>
        </div>
        <div className="card-ip">{peer.ip}</div>
        <div className="card-actions">
          <button className="card-btn dl" onClick={handleDownload}>
            ↓ Download .conf
          </button>
          <button className="card-btn qr" onClick={() => setShowQr(true)}>
            QR Code
          </button>
        </div>
      </div>
    </>
  );
}
